import { useState, useEffect } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { FaPen } from 'react-icons/fa'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { updateRecruteurEntrepriseAction } from '../actions/recruteurActions'
import Loading from '../components/Loading'

function UpdateEntreprise({ entreprise }) {
	const { recruteurId } = useParams()

	const [values, setValues] = useState({
		entreprise,
	})
	const [show, setShow] = useState(false)

	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const dispatch = useDispatch()

	const { success, loading, message } = useSelector((state) => state.recruteur)

	const onChange = (e) => {
		setValues({ ...values, [e.target.name]: e.target.value })
	}

	const onClick = () => {
		dispatch(updateRecruteurEntrepriseAction(recruteurId, values.entreprise))
	}

	useEffect(() => {
		if (success && message) {
			handleClose()
		}
	}, [success, message])

	return (
		<>
			<Button className='rounded-circle' onClick={handleShow}>
				<FaPen />
			</Button>{' '}
			<Modal show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Mettre à jour</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group className='mb-3'>
						<Form.Control
							type='text'
							placeholder='Entreprise'
							name='entreprise'
							value={values.entreprise}
							onChange={onChange}
						/>
					</Form.Group>
				</Modal.Body>
				<Modal.Footer>
					<Button variant='danger' onClick={handleClose}>
						Annuler
					</Button>
					<Button type='submit' onClick={onClick} disabled={loading && true}>
						Enregistrer {loading && <Loading sm='sm' />}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default UpdateEntreprise
